export const sessions = Array.from({ length: 67 }, (_, i) => `${2023 + i}/${2024 + i}`);

export const terms = ["FIRST TERM", "SECOND TERM", "THIRD TERM"];

export const classes = [
  "PLAYGROUP",
  "KG 1",
  "KG 2",
  "NURSERY 1",
  "NURSERY 2",
  "PRIMARY 1",
  "PRIMARY 2",
  "PRIMARY 3",
  "PRIMARY 4",
  "PRIMARY 5",
  "PRIMARY 6",
  "JSS 1",
  "JSS 2",
  "JSS 3",
  "SSS 1 ARTS",
  "SSS 1 SCIENCE",
  "SSS 1 COMMERCIAL",
  "SSS 2 ARTS",
  "SSS 2 SCIENCE",
  "SSS 2 COMMERCIAL",
  "SSS 3 ARTS",
  "SSS 3 SCIENCE",
  "SSS 3 COMMERCIAL",
];

export const studentStatus = ["New", "Returning"];
